import { filtering, sort } from '~/support/utils';

import ApiBase from './ApiBase';

export const COMPOSITES_ENDPOINT = 'composites';
export const DATASETS_ENDPOINT = 'datasets';
export const DATASETS_COUNT_ENDPOINT = 'count';
export const DELIVERIES_ENDPOINT = 'deliveries';
export const LATEST_DELIVERY = 'latest-delivery';
export const STATISTICS_ENDPOINT = 'statistics';
export const LOGS_ENDPOINT = 'logs';
export const LOGS_DISPATCH_ENDPOINT = 'dispatch';
export const LOGS_PDK_ENDPOINT = 'pdk';

export default class HealthService extends ApiBase {
  async fetchCompositeDatasets({ id, pageToken }) {
    const { data } = await this.client.get(`/${COMPOSITES_ENDPOINT}/${id}/${DATASETS_ENDPOINT}`, {
      params: {
        pageToken,
      },
    });

    return data;
  }

  async fetchComposites({ filters, pageToken, query }) {
    const filterParams = filters ? { filters: filtering.stringify(filters) } : {};
    const { data } = await this.client.get(`/${COMPOSITES_ENDPOINT}`, {
      params: {
        ...filterParams,
        pageToken,
        query,
      },
    });

    return data;
  }

  async fetchDataset(id) {
    const { data } = await this.client.get(`/${DATASETS_ENDPOINT}/${id}`);

    return data;
  }

  async fetchDatasetV2(id) {
    const { data } = await this.client.get(`/${DATASETS_ENDPOINT}/${id}/v2`);

    return data;
  }

  async fetchDatasetDelivery(datasetId, deliveryId) {
    const { data } = await this.client.get(`/${DATASETS_ENDPOINT}/${datasetId}/${DELIVERIES_ENDPOINT}/${deliveryId}`);

    return data;
  }

  async fetchDatasetDeliveryDispatchLogs({ datasetId, exportId }) {
    const { data } = await this.client.post(
      `/${DATASETS_ENDPOINT}/${datasetId}/${LOGS_ENDPOINT}/${LOGS_DISPATCH_ENDPOINT}`,
      {
        exportId,
      },
    );

    return data;
  }

  async fetchDatasetDeliveryPdkLogs({ datasetId, deliveryId }) {
    const { data } = await this.client.post(
      `/${DATASETS_ENDPOINT}/${datasetId}/${LOGS_ENDPOINT}/${LOGS_PDK_ENDPOINT}`,
      {
        deliveryId,
      },
    );

    return data;
  }

  async fetchDatasetDeliveryV2(deliveryId) {
    const { data } = await this.client.get(`/${DELIVERIES_ENDPOINT}/${deliveryId}`);

    return data;
  }

  async fetchDatasetLatestDelivery(id) {
    const { data } = await this.client.get(`/${DATASETS_ENDPOINT}/${id}/${LATEST_DELIVERY}`);

    return data;
  }

  async fetchDatasets() {
    const { data } = await this.client.get(`/${DATASETS_ENDPOINT}`);

    return data;
  }

  async fetchDatasetsCount() {
    const { data } = await this.client.get(`/${DATASETS_ENDPOINT}/${DATASETS_COUNT_ENDPOINT}`);

    return data;
  }

  async fetchDatasetsV2({ filters, pageToken, query, sortSettings }) {
    const params = filters ? { filters: filtering.stringify(filters, { noQuotes: true }) } : {};
    const { data } = await this.client.get(`/${DATASETS_ENDPOINT}/v2`, {
      params: { ...params, pageToken, query, sort: sort.stringify(sortSettings) },
    });

    return data;
  }

  async fetchDeliveryTaskHistory(deliveryId) {
    const { data } = await this.client.get(`/${DELIVERIES_ENDPOINT}/${deliveryId}/tasks`);

    return data;
  }

  async fetchStatistics() {
    const { data } = await this.client.get(`/${STATISTICS_ENDPOINT}`);

    return data;
  }

  async rerunDatasetDelivery(datasetId, deliveryId) {
    const { data } = await this.client.post(
      `/${DATASETS_ENDPOINT}/${datasetId}/${DELIVERIES_ENDPOINT}/${deliveryId}/rerun`,
    );

    return data;
  }
}
